/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Inventory_Search_PlaceholderInputs */

const vi_report_inventory_search_placeholder = /** @type {(inputs: Report_Inventory_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm theo tên sản phẩm hoặc SKU`)
};

/**

* @param {Report_Inventory_Search_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_inventory_search_placeholder = /** @type {((inputs?: Report_Inventory_Search_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Inventory_Search_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_inventory_search_placeholder(inputs)
});